<template>
  <div :class="{ 'has-logo': showLogo }" class="sidebar-wrapper">
    <div class="user-container">
      <span class="c-icon">
        <img
          src="../../../assets/images/icon/teacher.png"
          alt=""
          v-if="userInfo.category == 'teacher'"
        />
        <img src="../../../assets/images/icon/student.png" alt="" v-else />
      </span>
      <el-dropdown trigger="click" @command="handleToggleRole">
        <div>
          <span class="el-dropdown-link">
            {{ userInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            :command="item"
            v-for="item in userRoleList"
            :key="item.id"
            >{{ item.roleName }}</el-dropdown-item
          >
          <el-dropdown-item command="pwd" :divided="userRoleList.length != 0"
            >修改密码</el-dropdown-item
          >
          <el-dropdown-item command="exit">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="role-name">{{ roleName }}</div>

    <div class="sidebar-box">
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu
          class="el-menu-vertical-side"
          :default-active="defActive"
          mode="vertical"
          menu-trigger="click"
          router
          unique-opened
          :collapse="isCollapse"
        >
          <sidebar-item
            v-for="(item, n) in menuList"
            :item="item"
            :navIndex="String(n)"
            :key="item.id"
          ></sidebar-item>
        </el-menu>
      </el-scrollbar>
    </div>
    <!-- 修改密码弹框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            :formItems="formItems"
            @submit="submit"
            @resetFields="resetFields"
          >
          </c-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import CForm from "@/components/CForm/index.vue";
// import { listA, listB } from "@/assets/json/menuList";
import { mapState, mapActions } from "vuex";
import { Loading } from "element-ui";
import Configs from "./config";
import { hex_sha1 } from "@/libs/sha1.js";

export default {
  components: { Logo, SidebarItem, CForm },
  data() {
    let { formItems, formRules } = Configs(this);
    return {
      formItems,
      formRules,
      showLogo: true,
      userInfo: {},
      userRoleList: [],
      roleName: "",
      dialogFormVisible: false,
      // menuList: null,
      handleData: {
        oldPassword: "",
        newPassword: "",
        verifyPassword: "",
      },
      handleLoading: false,
    };
  },
  props: {
    isCollapse: Boolean,
  },
  watch: {
    isCollapse(val) {
      // console.log(val)
    },
  },
  computed: {
    ...mapState({
      menuList: (state) => state.auth.menuList,
      SUCCESS_CODE: (state) => state.dic.SUCCESS_CODE,
    }),
    defActive() {
      let route = this.$route;
      let active = "";
      if (route.meta.type == 2) {
        active = localStorage.getItem("backPath");
      } else {
        active = route.path;
      }
      return active;
    },
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    let roleId = userInfo.roleId;
    let roleName = localStorage.getItem("roleName");
    this.roleName = roleName ? roleName : "";
    // 如果用户有多个角色列表时，则进行切换展示,否则不展示角色切换项
    if (userInfo.userRoleList.length > 0) {
      if (roleId) {
        // 非学生
        if (userInfo.userRoleList.length > 1) {
          this.userRoleList = userInfo.userRoleList;
        }
      } else {
        // 学生
        this.userRoleList = userInfo.userRoleList;
        let first = { id: "student", roleId: "", roleName: "学生端" };
        this.userRoleList.unshift(first);
        console.log(this.userRoleList);
      }
    } else {
      this.userRoleList = [];
    }
    // this.userRoleList = [];
    // if (roleId) {
    //   this.menuList = listA;
    // } else {
    //   this.menuList = listB;
    // }
  },
  mounted() {},
  methods: {
    ...mapActions({
      initMenu: "auth/initMenu",
    }),
    handleOpen() {},
    handleClose() {},
    // 获取菜单列表
    getMenuList() {
      let roleId = JSON.parse(localStorage.getItem("userInfo")).roleId;
      this.$http
        .get("/account/sys/menu/getByRoleId?roleId=" + roleId)
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.menuList = res.data;
            console.log(this.menuList);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取失败" + err);
        });
    },
    // 切换角色或退出登录
    handleToggleRole(command) {
      console.log(command);
      if (command == "pwd") {
        // 用户修改密码，跳转到修改密码的页面
        // this.$router.push("/sys/users/modifyPwd");
        // 弹出修改密码弹框
        this.dialogFormVisible = true;
      } else if (command == "exit") {
        // 退出登录，清空localStorage
        localStorage.clear();
        this.$router.replace("/login");
        // 清除vuex中的数据
        this.$store.commit("auth/resetState");
      } else {
        let roleId = command.roleId;
        let roleName = command.roleName == "学生端" ? "" : command.roleName;
        let roleFlag = command.roleFlag ? command.roleFlag : "";
        localStorage.setItem("roleId", roleId ? roleId : "");
        localStorage.setItem("roleName", roleName);
        localStorage.setItem("roleFlag", roleFlag);
        this.$store.commit("auth/resetState");
        window.location.reload();
      }
    },
    handleDialogClose() {
      this.$refs.cForm.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
    // 修改密码
    submit() {
      this.handleLoading = true;
      let data = {
        oldPassword: hex_sha1(this.handleData.oldPassword),
        newPassword: hex_sha1(this.handleData.newPassword),
      };
      this.$http
        .post("/account/sys/user/changePwd", data)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            this.dialogFormVisible = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleLoading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.handleLoading = false;
        });
    },
  },
  beforeDestroy() {},
};
</script>
